import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserAPI } from '@supersports/services';
import { RootState } from './types';

export enum EventSorting {
  MATCH = 'MATCH',
  TIME = 'TIME',
}
export enum SelectMarketType {
  ALL = 'ALL',
  MAIN = 'MAIN',
  SPECIAL = 'SPECIAL',
}
export enum DisplayLiveMatchAnnouncement {
  ENABLE = 'E',
  DISABLE = 'D',
  MY_FAVORITE_ONLY = 'MFO',
}

export interface SettingState {
  OddsType: string;
  DefaultEventsSorting: EventSorting;
  SelectMarketType: SelectMarketType;
  DisplayLiveMatchAnnouncement: DisplayLiveMatchAnnouncement;
  MatchSoundAlert: boolean;
  ShowForecastSummary: boolean;
  PreferredStake: number;
  AutoAcceptBetterOdds: boolean;
  DisplayBetConfirmMsg: boolean;
  DisplayBetSuccessfullyMsg: boolean;
}

const initialState: SettingState = {
  OddsType: 'MY',
  DefaultEventsSorting: EventSorting.MATCH,
  SelectMarketType: SelectMarketType.ALL,
  DisplayLiveMatchAnnouncement: DisplayLiveMatchAnnouncement.MY_FAVORITE_ONLY,
  MatchSoundAlert: true,
  ShowForecastSummary: true,
  PreferredStake: 0,
  AutoAcceptBetterOdds: true,
  DisplayBetConfirmMsg: true,
  DisplayBetSuccessfullyMsg: false,
};

export const fetchSettings = createAsyncThunk(
  'setting/fetchSettings',
  async (payload: { token: string } | void, { getState }) => {
    const token = (payload as { token: string })?.token || (getState() as RootState).user.SsToken;
    const response = await UserAPI.getProviderSettings(token);
    return response as { BetLimits: any; UserPreferences: SettingState | null };
  }
);
export const saveUserPreferences = createAsyncThunk(
  'setting/saveUserPreferences',
  async (payload: Partial<SettingState> | void, { getState }) => {
    const state = getState() as RootState;

    const { SsToken } = state.user;
    const settings = state.setting;
    const mergedSettings = { ...settings, ...payload };

    await UserAPI.postUserPreferences(mergedSettings, SsToken);

    return { UserPreferences: mergedSettings };
  }
);

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    updateSetting(state, action: PayloadAction<Partial<SettingState>>) {
      Object.assign(state, action.payload);
    },

    restoreSetting(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.fulfilled, (state, action) => {
        Object.assign(state, action.payload.UserPreferences);
      })
      .addCase(saveUserPreferences.fulfilled, (state, action) => {
        Object.assign(state, action.payload.UserPreferences);
      });
  },
});

export const { updateSetting, restoreSetting } = settingSlice.actions;

export default settingSlice.reducer;
